import styled from "@emotion/styled"
import React, { forwardRef } from "react"
import Box, { BoxProps } from "./Box"

const BlueGlow = styled(Box)`
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(65, 148, 236, 0.24) 0%,
    rgba(65, 148, 236, 0) 100%
  );
`

const ForwardedBlueGlow = forwardRef<HTMLAllCollection, BoxProps>(
  ({ size, width, height, ...props }, ref) => (
    <BlueGlow
      ref={ref}
      width={size || width}
      height={size || height}
      {...props}
    />
  )
)

ForwardedBlueGlow.displayName = "BlueGlow"

export default BlueGlow
